module.exports = __webpack_public_path__ + "assets/img/message.c3b5fc3a.svg";